@if(data?.footer?.footer_copyright){
  <div class="footer-end">
    <p><i class="fa fa-copyright" aria-hidden="true"></i> {{ data?.footer?.copyright_content }}</p>
  </div>
}
